import Pie from './Pie/Pie';
import Bar from './Bar/Bar';

const templates = {
  Pie,
  Bar,
};

export default templates;